import tracking from './tracking.ts';

const quiz = {
  create(el) {
    this.el = el;
    this.$el = $(el);
    this.quizIsFinished = false;

    this.$el.on('click', '.js-quiz-answer', (event) => {
      if (this.quizIsFinished) {
        return;
      }

      this.handleAnswer(event.currentTarget);
    });
  },

  handleAnswer(buttonElement) {
    if (!this.isCorrect(buttonElement)) {
      buttonElement.classList.add('is-wrong');
    }

    this.highlightCorrectAnswers();

    this.markFinished();

    this.trackAnswer(buttonElement);

    if (!this.hasQuizzesLeft()) {
      this.showQuizResult();
      this.scrollToResults();
    }
  },

  markFinished() {
    this.quizIsFinished = true;
    this.el.classList.add('is-finished');
  },

  isCorrect(buttonElement) {
    return buttonElement.getAttribute('data-correct') === '1';
  },

  trackAnswer(buttonElement) {
    const question = this.$el.find('.js-quiz-question').text().trim();
    const answer = buttonElement.textContent.trim();
    const status = this.isCorrect(buttonElement) ? 'correct' : 'wrong';

    tracking.shootEvent('Quiz', `answer - ${question}`, `${status} - ${answer}`);
  },

  quizzes(onlyUnfinished = false) {
    const filter = onlyUnfinished ? ':not(.is-finished)' : '';
    return $(`.js-quiz${filter}`).toArray();
  },

  hasQuizzesLeft() {
    const $quizzes = this.quizzes(true);

    return $quizzes.length > 0;
  },

  hasWrongAnswer(quizElement) {
    return !!quizElement.querySelector('.is-wrong');
  },

  getResultBlock() {
    const $resultBlock = $('.js-quiz-result');

    if (!$resultBlock.length) {
      return null;
    }

    return $resultBlock;
  },

  showQuizResult() {
    const $resultBlock = this.getResultBlock();

    if (!$resultBlock) {
      return;
    }

    this.replaceResultTitle($resultBlock);
    this.replaceResultSocial($resultBlock);

    $resultBlock.removeAttr('hidden');
  },

  scrollToResults() {
    const $resultBlock = this.getResultBlock();

    if (!$resultBlock) {
      return;
    }

    $('body, html').animate({
      scrollTop: $resultBlock.offset().top - 150,
    });
  },

  replaceResultTitle($resultBlock) {
    const title = this.resultTitle($resultBlock);
    this.resultTitleElement($resultBlock).text(this.replaceResultsInText(title));
  },

  resultTitle($resultBlock) {
    return this.resultTitleElement($resultBlock).text().trim();
  },

  socialResultTitle($resultBlock) {
    return $resultBlock.data('social-title');
  },

  resultTitleElement($resultBlock) {
    return $resultBlock.find('.js-quiz-result-text');
  },

  replaceResultSocial($resultBlock) {
    const title = this.socialResultTitle($resultBlock);

    $resultBlock.find('.js-quiz-result-social').toArray().forEach((linkElement) => {
      let href = linkElement.getAttribute('href');

      if (href.indexOf('facebook.com/') >= 0) {
        const facebookTitle = encodeURIComponent(this.replaceResultsInText(title));
        href = `${href}?social_title=${facebookTitle}`;
      }

      linkElement.setAttribute('href', this.replaceResultsInText(href));
    });
  },

  replaceResultsInText(text) {
    const { wrong, correct, total } = this.getResults();
    let textInstance = text.replace(/(%23%23total%23%23|##total##)/g, total);
    textInstance = textInstance.replace(/%23%23correct%23%23|##correct##/g, correct);
    textInstance = textInstance.replace(/%23%23wrong%23%23|##wrong##/g, wrong);
    return textInstance;
  },

  getResults() {
    const wrong = this.quizzes().filter(this.hasWrongAnswer).length;
    const total = this.quizzes().length;
    return {
      wrong,
      total,
      correct: total - wrong,
    };
  },

  highlightCorrectAnswers() {
    const $correctAnswers = this.$el.find('[data-correct="1"]');

    $correctAnswers.toArray().forEach((element) => {
      element.classList.add('is-correct');
    });
  },
};

const $quizElements = $('.js-quiz');

export default {
  initialize() {
    $quizElements.toArray().forEach((element) => {
      ({ ...quiz }).create(element);
    });
  },
};
